import router from '@/router'
import config from '@/config'

const initialState = {
  sessionExpirationTime: config.sessionExpirationTime,
  sessionExpirationPopupTime: config.sessionExpirationPopupTime
}

export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setSessionExpirationTime(state, data) {
      state.sessionExpirationTime = data.data.time
    }
  },
  getters: {
    sessionExpirationPopupTime(state) {
      return state.sessionExpirationTime - state.sessionExpirationPopupTime
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    async logout({ dispatch }) {
      try {
        dispatch('resetState', {}, { root: true })
        await dispatch(
          'app/makeCall',
          {
            route: 'auth.logout'
          },
          { root: true }
        )
        router.push({ name: 'login' })
      } catch (error) {
        throw error.response
      }
    },
    async getThisUserInfo({ dispatch }) {
      try {
        const response = await dispatch(
          'app/makeCall',
          {
            route: 'auth.getThisUserInfo'
          },
          { root: true }
        )
        dispatch('user/setUserData', response.data.user, { root: true })
        return response
      } catch (error) {
        if (error.response.status === 401) {
          throw new Error('Credentials are incorrect')
        } else if (error.response.status === 400) {
          throw new Error('Validation error, bad data provided')
        } else if (error.response.status === 500) {
          throw new Error('Unknown Sign In Error')
        }
        throw new Error(error.response.data.message)
      }
    },
    async getExpirationTime({ dispatch, commit }) {
      try {
        commit(
          'setSessionExpirationTime',
          await dispatch(
            'app/makeCall',
            {
              route: 'auth.getExpirationTime'
            },
            { root: true }
          )
        )
      } catch (error) {
        throw error.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js